import WithdrawHelper from '@bet25/ui/WithdrawHelper'
import UserAdapter from '../../common/adapters/UserAdapter'
import NotificationConductor from '../../common/conductors/NotificationConductor'
import { ModalService } from 'services/ModalService'

export const storeBankInfoHandler = ({
    bankData,
    onSuccessCallback = () => {},
    onFinallyCallback = () => {},
    checkSession = () => {},
    cleanLocalStorage = false,
}) => {
    const {
        MIT_ID_ERRORS,
        NOTIFICATIONS,
        getWithdrawNotification,
    } = WithdrawHelper

    return UserAdapter.withdrawStoreBankInfo(bankData)
        .then((data) => {
            console.log('!!!UserAdapter.withdrawStoreBankInfo', data)
            if (MIT_ID_ERRORS.includes(data.reason)) {
                localStorage.setItem('bankData', JSON.stringify(bankData))

                setTimeout(() => {
                    ModalService.showModal('WITHDRAW_MIT_ID_POPUP')
                }, 200)

                //for dev
                // FetchAdapter.post(
                //     AUTH_REST_PATH + 'setSecurelyLoggedIn',
                //     { text: 'KSLDasdklm39rjfnajndr3297r4qaj' },
                //     { credentials: 'include' }
                // )
                //     .then((result) => {
                //         console.log('MitIdElevate result', result)
                //         if (result.success) {
                //             history.push('/konto/udbetaling')
                //         } else {
                //             console.log('Error', result.errorMessage)
                //         }
                //     })
                //     .catch((err) => {
                //         NotificationConductor.error(err.toString())
                //     })

                return
            }
            //checkSession()
            console.log('!!!onSuccessCallback')
            onSuccessCallback()

            const messageKey =
                data.bankName === 'ZIMPLER'
                    ? NOTIFICATIONS.ZIMPLER_SAVED
                    : NOTIFICATIONS.NEMKONTO_SAVED

            const { title, message } = getWithdrawNotification(
                messageKey,
                data.bankAcc
            )

            NotificationConductor.success(message, title)

            if (cleanLocalStorage) {
                localStorage.removeItem('bankData')
            }
        })
        .catch((e) => {
            NotificationConductor.error(e)
        })
        .finally(() => {
            onFinallyCallback()
        })
}
